// Create registration survey or cancel subcription survey
import { gql } from "@apollo/client";

const CREATE_SURVEY = gql`
  mutation Survey($input: SurveyInput!) {
    survey(input: $input) {
      survey {
        id
        student {
          givenName
          familyName
          email
        }
        surveyQuestions {
          id
          questionText
          questionType
        }
      }
    }
  }
`;

export default CREATE_SURVEY;
